// src/useLanguageDetection.ts
import { useEffect } from 'react';
import { franc } from 'franc';

export function useLanguageDetection() {
  useEffect(() => {
    const elements = document.querySelectorAll('.text-base');
    elements.forEach((el) => {
      const text = el.textContent || '';
      // テキストが短いと誤判定される可能性があるので、minLength を設定
      const langDetected = franc(text, { minLength: 10 });
      // 判定結果に応じて lang 属性を設定
      if (langDetected === 'jpn') {
        el.setAttribute('lang', 'ja');
      } else if (langDetected === 'eng') {
        el.setAttribute('lang', 'en');
      } else {
        // その他の場合はデフォルトで英語スタイルに設定
        el.setAttribute('lang', 'en');
      }
    });
  }, []);
}
